module.exports = __webpack_public_path__ + "static/header_usluge_DE-3765507c452dc9cc6048106ab585afd8.jpg";